export default __webpack_public_path__ + "static/media/survey3.59635dd3.svg";